import { WebSocketState, WebSocketAction, GenericWebSocketMessage } from "../types";

// Initial state
export const initialWebSocketState: WebSocketState = {
    connectionStatus: "Uninstantiated",
    isConnected: false,
    messages: [],
    lastMessage: null,
    error: null,
    reconnectAttempts: 0,
    maxReconnectAttempts: 5,
};

const addMessageToHistory = (messages: GenericWebSocketMessage[], newMessage: GenericWebSocketMessage): GenericWebSocketMessage[] => {
    const isDuplicate = messages.some(
        (msg) =>
            msg.action === newMessage.action &&
            JSON.stringify(msg.data) === JSON.stringify(newMessage.data) &&
            Math.abs((msg.timestamp || 0) - (newMessage.timestamp || 0)) < 1000
    );

    if (isDuplicate) {
        return messages;
    }

    const updatedMessages = [...messages, newMessage];
    return updatedMessages.length > 100 ? updatedMessages.slice(-100) : updatedMessages;
};

export const websocketReducer = (state: WebSocketState, action: WebSocketAction): WebSocketState => {
    switch (action.type) {
        case "CONNECTION_STATUS_CHANGED":
            return {
                ...state,
                connectionStatus: action.payload,
                isConnected: action.payload === "Open",
                error: action.payload === "Open" ? null : state.error,
            };

        case "MESSAGE_RECEIVED":
            console.log("📥 Received WebSocket message:", action.payload);
            return {
                ...state,
                messages: addMessageToHistory(state.messages, action.payload),
                lastMessage: action.payload,
                error: null,
            };

        case "ERROR_OCCURRED":
            return {
                ...state,
                error: action.payload,
            };

        case "CLEAR_MESSAGES":
            return {
                ...state,
                messages: state.messages.filter(action.payload),
                lastMessage: null,
            };

        case "RECONNECT_ATTEMPT":
            return {
                ...state,
                reconnectAttempts: state.reconnectAttempts + 1,
            };

        case "RESET_RECONNECT_ATTEMPTS":
            return {
                ...state,
                reconnectAttempts: 0,
            };

        default:
            return state;
    }
};
